import React, { useState, useEffect } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const ClientModal = ({
  isOpen,
  onClose,
  onSubmit,
  client = null,
  isLoading = false
}) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    phoneNumber: '',
    role: 'client',
    clientName: '',
    clientId: '',
    clientCode: '',
    status: 'active'
  });

  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [clientIdOptions, setClientIdOptions] = useState([]); // ✅ renamed from clientOptions

  const roleOptions = [
    { value: '3', label: 'Client' },
    { value: '4', label: 'Courier' },
    { value: '1', label: 'Admin' }
  ];

  const statusOptions = [
    { value: '1', label: 'Active' },
    { value: '0', label: 'Inactive' },
    { value: '2', label: 'Inprocess' }
  ];

  // ✅ Fetch client list from API
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (isOpen) {
      //fetch('https://lsorder.lakeetech.com/client/active', {
      fetch(`${import.meta.env.VITE_CATDEMO_BASE_URL}/client/active`, {
        headers: {
          'accept': '*/*',
          'Authorization': `Bearer ${token || ''}`
        }
      })
        .then(res => res.json())
        .then(data => {
          const options = data.map(item => ({
            value: item.client_id,
            label: item.client_name,
            code: item.client_code
          }));
          setClientIdOptions(options); // ✅ fixed
        })
        .catch(err => console.error('Error fetching clients:', err));
    }
  }, [isOpen]);

  // ✅ Populate form data when editing
  useEffect(() => {
    if (client) {
      setFormData({
        name: client?.name || '',
        email: client?.email || '',
        password: '',
        phoneNumber: client?.phoneNumber || '',
        role: client?.role || 'client',
        clientName: client?.clientName || '',
        clientId: client?.clientId || '',
        clientCode: client?.clientCode || '',
        status: client?.status || 'active'
      });
    } else {
      setFormData({
        name: '',
        email: '',
        password: '',
        phoneNumber: '',
        role: 'client',
        clientName: '',
        clientId: '',
        clientCode: '',
        status: 'active'
      });
    }
    setErrors({});
  }, [client, isOpen]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));

    if (errors?.[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }

    if (field === 'clientName' && value) {
      const generatedId = value
        ?.toLowerCase()
        ?.replace(/[^a-z0-9\s]/g, '')
        ?.replace(/\s+/g, '_')
        ?.substring(0, 20);
      setFormData(prev => ({
        ...prev,
        clientCode: `client_${generatedId}_${Date.now()?.toString()?.slice(-4)}`
      }));
    }
  };

  

  // ✅ Handle client selection from dropdown
  const handleClientSelect = (selectedValue) => {
    const selectedClient = clientIdOptions.find(opt => opt.value === selectedValue);
    if (selectedClient) {
      setFormData(prev => ({
        ...prev,
        clientId: selectedClient.value,
        clientName: selectedClient.label,
        clientCode: selectedClient.code
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData?.name?.trim()) {
      newErrors.name = 'Name is required';
    } else if (formData?.name?.trim()?.length < 2) {
      newErrors.name = 'Name must be at least 2 characters';
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData?.email?.trim()) {
      newErrors.email = 'Email is required';
    } else if (!emailRegex?.test(formData?.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (!client && !formData?.password) {
      newErrors.password = 'Password is required';
    } else if (!client && formData?.password?.length < 8) {
      newErrors.password = 'Password must be at least 8 characters';
    }

    const phoneRegex = /^\+?[\d\s\-\(\)]{10,}$/;
    if (!formData?.phoneNumber?.trim()) {
      newErrors.phoneNumber = 'Phone number is required';
    } else if (!phoneRegex?.test(formData?.phoneNumber)) {
      newErrors.phoneNumber = 'Please enter a valid phone number';
    }

    if (!formData?.clientName?.trim()) {
      newErrors.clientName = 'Client name is required';
    }

    if (!formData?.clientCode?.trim()) {
      newErrors.clientCode = 'Client Code is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  // const handleSubmit = (e) => {
  //   e?.preventDefault();
  //   if (validateForm()) {
  //     const submitData = { ...formData };
  //     if (client && !submitData?.password) {
  //       delete submitData?.password;
  //     }
  //     onSubmit(submitData);
  //   }
  // };

//   const handleSubmit = async (e) => {
//   e?.preventDefault();

//   if (!validateForm()) return;

//   const token = localStorage.getItem('authToken');

//   // Map form fields to API keys
//   const payload = {
//     name: formData.name,
//     email: formData.email,
//     password: formData.password,
//     phno: Number(formData.phoneNumber), // Ensure it's a number
//     role: Number(formData.role), // Convert to number
//     send_email: 0, // default 0
//     client_code: formData.clientCode,
//     client_name: formData.clientName,
//     client_id: Number(formData.clientId)
//   };

//   // If editing and no password entered, remove password from payload
//   if (client && !formData.password) {
//     delete payload.password;
//   }

//   try {
//     const res = await fetch('https://lvalidate.lakeetech.com/register', {
//       method: 'POST',
//       headers: {
//         'accept': '*/*',
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify(payload)
//     });

//     const data = await res.json();

//     if (res.ok) {
//       console.log('Client created successfully:', data);
//       onSubmit(data); // Call parent refresh
//       handleClose();  // Close modal
//     } else {
//       console.error('Failed to create client:', data);
//       setErrors({ apiError: data?.message || 'Something went wrong' });
//     }
//   } catch (err) {
//     console.error('API request error:', err);
//     setErrors({ apiError: 'Network error, please try again' });
//   }
// };

const [popupMessage, setPopupMessage] = useState(null); // { type: 'success' | 'error', text: string }

const handleSubmit = async (e) => {
  e?.preventDefault();

  if (!validateForm()) return;

  const token = localStorage.getItem('authToken');

  const payload = {
    name: formData.name,
    email: formData.email,
    password: formData.password,
    phno: Number(formData.phoneNumber),
    role: Number(formData.role),
    send_email: 0,
    client_code: formData.clientCode,
    client_name: formData.clientName,
    client_id: Number(formData.clientId)
  };

  if (client && !formData.password) {
    delete payload.password;
  }

  try {
    const res = await fetch(`${import.meta.env.VITE_AUTH_BASE_URL}/register`, {
      method: 'POST',
      headers: {
        'accept': '*/*',
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const data = await res.json();

    if (res.ok && data?.status === "success") {
      // ✅ Success popup
      setPopupMessage({ type: 'success', text: data?.message || 'Client created successfully' });
      setTimeout(() => {
        setPopupMessage(null);
        onSubmit(data);
        handleClose();
      }, 2000);
    } else {
      // ❌ Error popup (API-provided message)
      setPopupMessage({ 
        type: 'error', 
        text: data?.message || `Failed to create client (HTTP ${res.status})`
      });
      setTimeout(() => setPopupMessage(null), 4000);
    }
  } catch (err) {
    // ❌ Network/other error popup
    setPopupMessage({ type: 'error', text: 'Network error, please try again' });
    setTimeout(() => setPopupMessage(null), 4000);
  }
};



  const handleClose = () => {
    setFormData({
      name: '',
      email: '',
      password: '',
      phoneNumber: '',
      role: 'client',
      clientName: '',
      clientId: '',
      clientCode: '',
      status: 'active'
    });
    setErrors({});
    onClose();
  };

  if (!isOpen) return null;

  

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 z-90" onClick={handleClose} />
      <div className="fixed inset-0 z-100 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <div className="bg-card border border-border rounded-lg shadow-modal w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-border">
              <div>
                <h2 className="text-xl font-semibold text-foreground">
                  {client ? 'Edit Client' : 'Add New Client'}
                </h2>
                <p className="text-sm text-muted-foreground mt-1">
                  {client ? 'Update client information and permissions' : 'Create a new client account with API access'}
                </p>
              </div>
              <Button
                variant="ghost"
                size="sm"
                iconName="X"
                onClick={handleClose}
                className="h-8 w-8 p-0"
              />
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit} className="p-6 space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Name */}
                <Input
                  label="Name"
                  type="text"
                  placeholder="Enter full name"
                  value={formData?.name}
                  onChange={(e) => handleInputChange('name', e?.target?.value)}
                  error={errors?.name}
                  required
                />

                {/* Email */}
                <Input
                  label="Email Address"
                  type="email"
                  placeholder="Enter email address"
                  value={formData?.email}
                  onChange={(e) => handleInputChange('email', e?.target?.value)}
                  error={errors?.email}
                  required
                />

                {/* Password */}
                <div className="relative">
                  <Input
                    label={client ? "New Password (leave blank to keep current)" : "Password"}
                    type={showPassword ? "text" : "password"}
                    placeholder={client ? "Enter new password" : "Enter password"}
                    value={formData?.password}
                    onChange={(e) => handleInputChange('password', e?.target?.value)}
                    error={errors?.password}
                    required={!client}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-8 text-muted-foreground hover:text-foreground transition-colors"
                  >
                    <Icon name={showPassword ? "EyeOff" : "Eye"} size={16} />
                  </button>
                </div>

                {/* Phone Number */}
                <Input
                  label="Phone Number"
                  type="tel"
                  placeholder="9882400001"
                  value={formData?.phoneNumber}
                  onChange={(e) => handleInputChange('phoneNumber', e?.target?.value)}
                  error={errors?.phoneNumber}
                  required
                />

                {/* Role */}
                <Select
                  label="Role"
                  options={roleOptions}
                  value={formData?.role}
                  onChange={(value) => handleInputChange('role', value)}
                  required
                />

                {/* Status */}
                <Select
                  label="Account Status"
                  options={statusOptions}
                  value={formData?.status}
                  onChange={(value) => handleInputChange('status', value)}
                  required
                />

                {/* Select Client Dropdown */}
                <Select
                  label="Select Client"
                  options={clientIdOptions}
                  value={formData?.clientId}
                  onChange={handleClientSelect}
                />
              </div>

              {/* Client Information */}
              <div className="border-t border-border pt-6">
                <h3 className="text-lg font-medium text-foreground mb-4">Client Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Client Name */}
                  <Input
                    label="Client Name"
                    type="text"
                    placeholder="Auto-generated Company name"
                    value={formData?.clientName}
                    onChange={(e) => handleInputChange('clientName', e?.target?.value)}
                    error={errors?.clientName}
                    // description="This will be used for API identification"
                    required
                  />

                  {/* Client Code */}
                  <Input
                    label="Client Code"
                    type="text"
                    placeholder="Auto-generated client code"
                    value={formData?.clientCode}
                    onChange={(e) => handleInputChange('clientCode', e?.target?.value)}
                    error={errors?.clientCode}
                    // description="Unique identifier for API access"
                    required
                  />
                </div>
              </div>

              {/* Actions */}
              <div className="flex items-center justify-end space-x-3 pt-6 border-t border-border">
                <Button
                  type="button"
                  variant="outline"
                  onClick={handleClose}
                  disabled={isLoading}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  loading={isLoading}
                  iconName={client ? "Save" : "Plus"}
                >
                  {client ? 'Update Client' : 'Create Client'}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {popupMessage && (
  <div
    className={`fixed bottom-5 right-5 px-4 py-3 rounded shadow-lg text-white z-[99999]`}
    style={{ minWidth: '250px' }}
  >
    <div className={`${popupMessage.type === 'success' ? 'bg-green-500' : 'bg-red-500'} p-2 rounded`}>
      {popupMessage.text}
    </div>
  </div>
)}

    </>
  );
};

export default ClientModal;
